export default __webpack_public_path__ + "static/media/CrimsonPro-Bold.04e40610.ttf";